export default __webpack_public_path__ + "static/media/quickIcon.d53d1363.svg";